var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M23.375,18.9424509 L23.375,23.375 L0.625,23.375 L0.625,18.9424509 L23.375,18.9424509 Z M23.375,9.54888633 L23.375,13.9814354 L0.625,13.9814354 L0.625,9.54888633 L23.375,9.54888633 Z M23.375,0.625 L23.375,5.0575491 L0.625,5.0575491 L0.625,0.625 L23.375,0.625 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/Menu.5aa11ef311728817ec1c33ccef3f2f3d.svg";
export { ForwardRef as ReactComponent };